
enum VALIDATION_TYPES {
  OEM = 'OEM',
  VAS = 'VAS',
  RENTAL = 'RENTAL',
}

export { VALIDATION_TYPES }
